import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
  notifications: []
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotification: (state, action) => {
      state.open = true;
      state.notifications.push({
        severity: action.payload.severity,
        message: action.payload.message
      });
    },
    clearNotifications: (state) => {
      state.open = false;
      state.notifications = [];
    },
  },
});

export const { setNotification, clearNotifications } = notificationSlice.actions;
export default notificationSlice.reducer;
